import * as R from 'ramda'
import rentIncome from './rentIncome'
import expenses from './expenses'
import netIncome from './netIncome'
import moment from 'moment'

export default (transactions, period) => {
	transactions = R.filter(x => moment(period.from) <= moment(x.dueDate) && moment(period.to) >= moment(x.dueDate))(transactions)
	let invoicesByPropertyID = R.pipe(R.values, R.filter(x => x.type == 'transaction/invoice'), R.groupBy(R.prop('propertyID')))(transactions)
	let billsByPropertyID = R.pipe(R.values, R.filter(x => x.type == 'transaction/bill'), R.groupBy(R.prop('propertyID')))(transactions)

	let monthlyRentIncome = rentIncome(invoicesByPropertyID)
	let monthlyExpenses = expenses(billsByPropertyID)
	let monthlyNetIncome = netIncome(invoicesByPropertyID, billsByPropertyID)

	return ({
		rentIncome: monthlyRentIncome
	  , expenses: monthlyExpenses
	  , netIncome: monthlyNetIncome
	})
}



// WEBPACK FOOTER //
// ./src/helpers/kpi/monthlyStatement.js